import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enTranslations from './translations/en';
import frTranslations from './translations/fr';

// Initialize i18next
const initializeI18n = async () => {
  await i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources: {
        en: { translation: enTranslations },
        fr: { translation: frTranslations },
      },
      lng: localStorage.getItem('i18nextLng') || 'en',
      fallbackLng: 'en',
      supportedLngs: ['en', 'fr'],
      debug: process.env.NODE_ENV === 'development',
      interpolation: {
        escapeValue: false, // React already escapes values
      },
      detection: {
        order: ['localStorage', 'navigator'],
        caches: ['localStorage'],
        lookupLocalStorage: 'i18nextLng',
      },
      react: {
        useSuspense: false, // We'll handle suspense manually
      },
    });

  // Set initial document attributes
  document.documentElement.lang = i18n.language;
  document.documentElement.dir = i18n.dir(i18n.language);

  return i18n;
};

export { initializeI18n };
export default i18n;